<template>
    <v-app>
        <alpha-calendar-cancel-meeting-dialog
            :eventid="eventId"
            :assignment-id="assignmentId"
            @close="goBack(assignmentId)"
        />
    </v-app>
</template>

<script>
export default {
    name: 'AlphaCalendarCancelMeeting',
    props: {
        eventId: {
            type: Number,
            required: true,
        },
        assignmentId: {
            type: Number,
            required: true,
        }
    },
    data: () => ({
        cancelMeetingDialog: false,
        eventActiveID: null,
    }),
    methods: {
        goBack (assignmentId){
            window.location.href = `/admin/assignment/new-calendar/${assignmentId}/availabilities`
        }
    }
}
</script>

<style scoped lang="scss">
.v-event-draggable {
    padding-left: 7px;
}

.v-event-timed {
    user-select: none;
    -webkit-user-select: none;
}

.v-event-drag-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4px;
    height: 4px;
    cursor: ns-resize;

    &::after {
        display: none;
        position: absolute;
        left: 50%;
        height: 4px;
        border-top: 1px solid white;
        border-bottom: 1px solid white;
        width: 16px;
        margin-left: -8px;
        opacity: 0.8;
        content: "";
    }

    &:hover::after {
        display: block;
    }
}

.toolbar-margin {
    margin-right: 16px;
}

::v-deep .v-select__selections {
    flex-wrap: nowrap;
}

.cal-title {
    font-size: 18px;
    font-weight: 400;
    line-height: 2rem;
}

.v-btn {
    height: 40px !important;
}

.v-current-time {
    height: 2px;
    background-color: #ea4335;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;

    &.first::before {
        content: "";
        position: absolute;
        background-color: #ea4335;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-top: -5px;
        margin-left: -6.5px;
    }
}

@media only screen and (max-width: 768px) {
    .v-btn {
        font-size: x-small;
        height: 38px !important;
    }

    .row.btn-left-margin button,
    .cal-title {
        margin-bottom: 25px !important;
    }

    .spacer {
        height: 30px;
    }

    .toolbar-col {
        display: flex;
        justify-content: space-around !important;
        align-items: center;
    }
    ::v-deep .v-select__selections {
        font-size: 12px;
        line-height: 16px;
    }
}

@media only screen and (max-width: 600px) {
    .v-btn {
        height: 39px;
        min-width: 62px;
        padding: 0 5px !important;
    }

    .toolbar-col {
        justify-content: space-between !important;
        margin-bottom: -30px !important;
        @media only screen and (max-width: 420px) {
            margin-bottom: 20px !important;
            &:not(:last-of-type) {
                margin-bottom: -20px !important;
            }
        }
    }
}

.toolbar-col {
    @media only screen and (max-width: 420px) {
        margin-bottom: 20px !important;
        &:not(:last-of-type) {
            margin-bottom: -20px !important;
        }
    }
}

.v-btn {
    @media only screen and (max-width: 420px) {
        height: 39px;
        min-width: auto;
        padding: 0 5px !important;
    }
}

@media only screen and (max-width: 420px) {
    .toolbar-margin {
        margin-right: 5px;
    }
    .cal-title {
        font-size: 15px;
    }
}

@media only screen and (max-width: 350px) {
    .v-btn {
        padding: 0 4px !important;
    }

    .toolbar-col {
        padding: 10px 0;
    }
}
</style>
